import { AppButton, AppRadioBox, AppSwitchBox, AppTextField } from 'components';
import { memo, useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getRandomUid } from 'utilities/uuid.service';
import * as AppPics from 'assets/images';
import Editor from 'components/CKEditor/Editor';
import { ReactSortable } from 'react-sortablejs';
import { EditorPreviewContext } from 'context/EditorPreviewContext';
// import HandleDelete from '../HandleDelete';
import useDebounce from 'hooks/useDebounce';
import QuizSectionsSettings from './QuizSectionsSettings';
import useQueryParams, { QueryParamsAsString } from 'hooks/useQueryParams';
import Select from 'react-select';
import { mcqOptions } from '.';

function MCQ({ editMode, selectedCategory, toggleView, handleSave, data, configs }) {
  const history = useHistory();
  const { PreviewBtn } = useContext(EditorPreviewContext);

  const queryParams = useQueryParams();
  const paperId = queryParams.get('paperId');

  const queryString = QueryParamsAsString();

  const { quizID, courseID, chapterID, classID } = useParams();

  const [title, setTitle] = useState('');
  const [section, setSection] = useState();

  const [hint, setHint] = useState('');
  const [explanation, setExplanation] = useState('');
  const [marks, setMarks] = useState('');

  const [options, setOptions] = useState([
    { id: getRandomUid(), option: '', isCorrect: false },
    { id: getRandomUid(), option: '', isCorrect: false },
  ]);
  const [qStatus, setQStatus] = useState('active');
  const [category, setCategory] = selectedCategory ?? [];
  const [showForm, toggleShowForm] = toggleView ?? [];
  const {
    hideSaveBtn = false,
    hideTopBtnSection = false,
    UID,
    deleteConfig,
    showRating,
  } = configs ?? {};

  const [settings, setSettings] = useState({});

  function handleQuizQuestion(quizFormData = {}) {
    if (!options.some((x) => x.isCorrect)) {
      window.alert('Please specify at least 1 correct option');
      return;
    }
    handleSave(quizFormData);
  }

  useEffect(() => {
    if (data?.data) {
      if (data?.data?.options) {
        setOptions(
          data?.data?.options?.map?.((item) => {
            if (item._id) item.id = item._id;
            return item;
          })
        );
      }
      setTitle(data?.data?.title || '');
      setQStatus(data?.data?.status || 'active');
      setHint(data?.data?.hint ?? '');
      setExplanation(data?.data?.explanation ?? '');
      setMarks(data?.data?.marks ?? '');
      setSection(data?.data?.sectionId ?? '');

      const __settings = {
        difficultyLevel: data?.data?.difficultyLevel,
        assessmentObjective: data?.data?.assessmentObjective,
        examBoard: data?.data?.examBoard,
        askedInYear: data?.data?.askedInYear,
      };
      setSettings((x) => ({ ...x, ...__settings }));
    }
  }, [data?.data, setCategory]);

  const [currentEdited, updateCurrentEditBlock] = useState({});

  const editorData = useDebounce(currentEdited, 100);

  useEffect(() => {
    if (editorData.id) {
      // updateCurrentEditBlock(editorData);
      setOptions(
        options.map((x) => {
          if (x.id === editorData.id) x.option = editorData.data;
          return x;
        })
      );
    }
  }, [editorData]);

  return (
    <>
      <div className="tab__content-actBody">
        <div className="px-5">
          {!hideTopBtnSection && (
            <div className="row justify-content-end my-4">
              <div className="col-12">
                {!editMode && (
                  <AppButton
                    variantClass="btn-plane p--tint mx-2"
                    onClick={() => {
                      setOptions([
                        { id: getRandomUid(), option: '', isCorrect: false },
                        { id: getRandomUid(), option: '', isCorrect: false },
                      ]);
                      setTitle('');
                      toggleShowForm(!showForm);
                    }}
                  >
                    Change question type
                  </AppButton>
                )}
                <AppButton
                  variantClass="btn-plane mx-2"
                  onClick={() => {
                    history.push(
                      `/classes/${classID}/courses/${courseID}/chapters/${chapterID}/quizzes/${quizID}/questions${queryString}`
                    );
                  }}
                >
                  Back to questions list
                </AppButton>
              </div>
            </div>
          )}

          {true && (
            <div className="row mt-4">
              <div className="col-md-12 col-lg-12 col-sm-12 mb-4">
                <div className="lessonWrap lessonWrap--border topalign __M_C_Q_">
                  <label htmlFor="">QUESTION </label>
                  {/* <button className="lessonWrap__btn floatright mr-4">
                      <img src={AppPics.DownArrowSvg} alt="" />
                    </button> */}
                  <div className="w-50">
                    <div className="d-flex align-items-center">
                      <span className="radioBlock">
                        <input
                          id={UID ? `choice-${UID}` : 'choice'}
                          name={UID ? `choice-${UID}` : 'choice'}
                          value={UID ? `choice-${UID}` : 'choice'}
                          type="radio"
                          defaultChecked={true}
                        />
                        <label htmlFor={UID ? `choice-${UID}` : 'choice'}>
                          Multiple Choice Question having
                        </label>
                      </span>
                    </div>
                    <div className="w-75 p-3">
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: '#e9baf0',
                            'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
                          }),
                        }}
                        className="basic-single"
                        classNamePrefix="select"
                        name="mcqOptionsDQ"
                        options={mcqOptions}
                        value={mcqOptions.find?.((x) => x.value === category)}
                        onChange={(args) => {
                          if (args.value === 'single') {
                            setOptions(
                              options.map((x) => {
                                x.isCorrect = false;
                                return x;
                              })
                            );
                          }
                          setCategory(args.value);
                        }}
                      />
                      {/* <select
                        required
                        value={category}
                        onChange={(event) => {
                          if (event.target.value === 'single') {
                            setOptions(
                              options.map((x) => {
                                x.isCorrect = false;
                                return x;
                              })
                            );
                          }
                          setCategory(event.target.value);
                        }}
                      >
                        <option value="single">Only One Correct Answer</option>
                        <option value="multiple">More than One Correct Answer</option>
                      </select> */}
                    </div>
                  </div>

                  <div className="my-4">
                    <div className="w-100 p-3">
                      <QuizSectionsSettings
                        selectedItemId={section}
                        selectedPaperId={paperId}
                        handleChange={(id) => setSection(id)}
                        prefix={'mcqQs' + data?.data?._id}
                        extras={{
                          settings,
                          setSettings: (item = {}) => setSettings((x) => ({ ...x, ...item })),
                        }}
                      />
                    </div>
                  </div>

                  <div className="w-100 p-3">
                    <label htmlFor="">Question</label>
                    {title && <PreviewBtn block={{ value: title }} />}
                    <Editor
                      data={{
                        value: title,
                        onChange: (data) => setTitle(data),
                      }}
                    />
                  </div>

                  <ReactSortable list={options} setList={setOptions} handle=".grabHandleID">
                    {options?.map((choice, index) => {
                      return (
                        <div className="lessonWrap  topalign py-0 grabHandleID" key={choice.id}>
                          <div className="w-100 p-3">
                            <label htmlFor="">Choice #{index + 1}</label>
                            <span className="radioBlock floatright">
                              {category === 'single' && (
                                <AppRadioBox
                                  inputProps={{
                                    id: `choice-${choice.id}`,
                                    name: `choice-${choice.id}`,
                                    checked: choice.isCorrect,
                                    onChange: () => {
                                      setOptions(
                                        options.map((x) => {
                                          x.isCorrect = false;
                                          if (x.id === choice.id) x.isCorrect = true;
                                          return x;
                                        })
                                      );
                                    },
                                  }}
                                  labelProps={{ label: 'This is the correct Answer' }}
                                />
                              )}
                              {category === 'multiple' && (
                                <AppSwitchBox
                                  inputProps={{
                                    checked: choice.isCorrect,
                                    onChange: (event) => {
                                      setOptions(
                                        options.map((x) => {
                                          if (x.id === choice.id)
                                            x.isCorrect = event.target.checked;
                                          return x;
                                        })
                                      );
                                    },
                                  }}
                                  labelProps={{ label: 'This is a correct answer' }}
                                />
                              )}
                            </span>

                            <AppButton
                              variantClass="lessonWrap__btn leftpos dublicate"
                              title="Clone"
                              onClick={() => {
                                setOptions(
                                  options.concat({
                                    id: getRandomUid(),
                                    option: choice.option,
                                    isCorrect: false,
                                  })
                                );
                              }}
                            >
                              <img src={AppPics.StampSvg} alt="clone this option" />
                            </AppButton>
                            <AppButton
                              variantClass="lessonWrap__btn leftpos delete"
                              onClick={() => {
                                setOptions(options.filter((x) => x.id !== choice.id));
                              }}
                            >
                              <img src={AppPics.DeleteSvg} alt="delete this option" />
                            </AppButton>
                            {choice.option && <PreviewBtn block={{ value: choice.option }} />}
                            <Editor
                              data={{
                                value: choice.option,
                                onChange: (data) => updateCurrentEditBlock({ id: choice.id, data }),
                                // setOptions(
                                //   options.map((x) => {
                                //     if (x.id === choice.id) x.option = data;
                                //     return x;
                                //   })
                                // ),
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </ReactSortable>

                  <div className="col-12">
                    <AppButton
                      variantClass="btn-plane p--tint m-l-btn"
                      onClick={() => {
                        setOptions(
                          options.concat({
                            id: getRandomUid(),
                            option: '',
                            isCorrect: false,
                          })
                        );
                      }}
                    >
                      + Add Choice
                    </AppButton>
                  </div>

                  <div className="w-100 p-3 mt-4">
                    <label htmlFor="">Hint</label>
                    {hint && <PreviewBtn block={{ value: hint }} />}
                    <Editor
                      data={{
                        value: hint,
                        onChange: (data) => setHint(data),
                      }}
                    />
                  </div>
                  <div className="w-100 p-3">
                    <label htmlFor="">Explanation</label>
                    {explanation && <PreviewBtn block={{ value: explanation }} />}
                    <Editor
                      data={{
                        value: explanation,
                        onChange: (data) => setExplanation(data),
                      }}
                    />
                  </div>
                  <div className="w-100 p-3">
                    <AppTextField
                      labelProps={{ label: 'Marks' }}
                      inputProps={{
                        placeholder: 'Please provide the maximum marks allocated',
                        value: marks || '',
                        onChange: (event) => setMarks(event.target.value),
                      }}
                    />
                  </div>

                  {/* {!hideSaveBtn && ( */}
                  {!showRating && (
                    <div className="mb-5 btnTab-foot mt-5">
                      <AppButton
                        className={`btn-right-content ${!hideSaveBtn ? 'save' : 'btn-plane'}`}
                        onClick={() => {
                          handleQuizQuestion({
                            title,
                            category,
                            options,
                            status: qStatus,
                            questionType: 'choice',
                            hint,
                            explanation,
                            marks,
                            section,
                            ...settings,
                          });
                        }}
                      >
                        {!hideSaveBtn ? 'Save Changes' : 'Save'}
                      </AppButton>
                      {/* {deleteConfig?.showBtn && (
                        <HandleDelete handleDelete={deleteConfig?.handleDelete} />
                      )} */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default memo(MCQ);
